import React from 'react';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import GuideInfoBox from '../components/GuideInfoBox';
import GuideMockChip from '../components/GuideMockChip';
import GuideMockContainer from '../components/GuideMockContainer';
import GuidePageLayout from '../components/GuidePageLayout';
import GuideSection from '../components/GuideSection';
import GuideStepList from '../components/GuideStepList';
import GuideTable from '../components/GuideTable';

const GuidePartnerSearch: React.FC = () => {
  return (
    <GuidePageLayout
      title="パートナーを検索する"
      description="条件を指定してパートナーを絞り込み検索します。"
      breadcrumbs={[{ label: 'パートナー管理', path: '/guide/partner/overview' }]}
    >
      <GuideSection title="前提">
        <GuideTable
          headers={['条件', '内容']}
          rows={[
            ['必要な権限', '管理者 / 管理部門 / 課長'],
            ['ログイン状態', 'ログイン済みであること'],
          ]}
        />
      </GuideSection>

      <GuideSection title="手順">
        <GuideStepList
          steps={[
            { label: 'パートナー管理画面を開く' },
            {
              label: '検索条件を入力する（全て任意、未入力で全件検索）',
              content: (
                <GuideMockContainer label="検索条件チップ">
                  <Stack direction="row" spacing={1} flexWrap="wrap">
                    <GuideMockChip label="パートナー名: サンプル" color="info" />
                    <GuideMockChip label="パートナー名（カナ）: サンプル" color="info" />
                    <GuideMockChip label="パートナー種別: 法人" color="secondary" />
                    <GuideMockChip label="契約終了を含む" color="default" />
                  </Stack>
                </GuideMockContainer>
              ),
            },
            { label: '「検索」ボタンを押下する' },
            { label: '検索結果がパートナー名カナの昇順で一覧表示される' },
          ]}
        />
      </GuideSection>

      <GuideSection title="検索条件">
        <GuideTable
          headers={['項目名', '形式', '検索方法', '備考']}
          rows={[
            ['パートナー名', 'テキスト', '前方一致', ''],
            ['パートナー名（カナ）', 'カタカナテキスト', '前方一致', ''],
            ['パートナー種別', 'プルダウン', '完全一致', '法人 / 個人事業主'],
            ['契約終了を含む', 'チェックボックス', '—', 'ONで契約終了済みも表示'],
          ]}
        />
      </GuideSection>

      <GuideSection title="検索結果一覧の表示">
        <GuideTable
          headers={['表示項目', '位置', '説明']}
          rows={[
            ['パートナー名', 'メイン（左）', 'パートナーの表示名'],
            ['契約状態Chip', 'メイン（右）', '契約中 or 契約終了を表示'],
            [
              'パートナー名（カナ） / 担当者名',
              'サブテキスト',
              'カナ名と担当者名（登録がある場合）',
            ],
          ]}
        />
        <GuideMockContainer label="リスト項目の表示例">
          <Stack spacing={1}>
            <Stack direction="row" alignItems="center" justifyContent="space-between">
              <Typography variant="body2" fontWeight={500}>
                株式会社サンプル
              </Typography>
              <GuideMockChip label="契約中" color="primary" size="small" />
            </Stack>
            <Typography variant="caption" color="text.secondary">
              カブシキガイシャサンプル / 山田太郎
            </Typography>
          </Stack>
        </GuideMockContainer>
        <GuideTable
          headers={['Chip', '意味', '表示条件', '色']}
          rows={[
            [
              '契約中',
              '現在契約が有効',
              '契約終了日が未設定、または契約終了日が現在日以降',
              '青（primary）',
            ],
            ['契約終了', '契約が終了している', '契約終了日が現在日より前', 'グレー（default）'],
          ]}
        />
      </GuideSection>

      <GuideSection title="注意事項">
        <Stack spacing={1}>
          <GuideInfoBox>デフォルトでは契約中のパートナーのみ表示されます。</GuideInfoBox>
          <GuideInfoBox>
            契約終了済みのパートナーを確認したい場合は「契約終了を含む」にチェックを入れてください。
          </GuideInfoBox>
          <GuideInfoBox>表示件数には上限があります。条件を絞って検索してください。</GuideInfoBox>
        </Stack>
      </GuideSection>
    </GuidePageLayout>
  );
};

export default GuidePartnerSearch;
